import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Row,
  Button,
  Input,
  InputGroup,
  Card,
  CardBody,
  CardHeader,
} from "reactstrap";
import "./adsPayment.css";
import PaypalExpressBtn from "react-paypal-express-checkout";
import cookie from "react-cookies";
import axios from "axios";
import Env from "../../../environment/environment";
import creditcardutils from "creditcardutils";
import Ads from "../addadvertise/Ads";
import Yncoin from "../../../assets/img/YNcoin.png";
import { PayPalButton } from "react-paypal-button-v2";

var payment_message = "Payment is in progress. Please do not refresh page.";
const AdsPayment = (props) => {
  let state = {
    paymentChecked: true,
    paypalChecked: true,
    ynCoinChecked: true,
    ynCoinConfirmed: false,
    yinnCoinExchangeValue: null,
    card: {
      number: "",
      exp_month: "01",
      exp_year: "",
      cvv: "",
      zip: "",
      payment_token: "",
    },
    userCardDetails: {
      user_id: "",
      braintree_customer_id: "",
      cards: [],
      card: {
        number: "",
        exp_date: "",
        cvv: "",
        zip: "",
        payment_token: "",
      },
      amount_payable: 0,
    },
    creditCardNumber: "",
    cvvMaxLength: 3,
    month: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
    orders: [],
    wallets: [],
    adBlcoked: false,
  };
  let payment_details = {};
  // constructor(props) {
  //     super(props);
  //     payment_details = JSON.parse(localStorage.getItem('ads_data'));
  //     state.userCardDetails.amount_payable = payment_details.pay
  //     payByCard = payByCard;
  //     payByPaypal = payByPaypal;
  //     payByYnCoin = payByYnCoin;
  // }

  const componentDidMount = () => {
    // sets the exchange value for yinn coin. used in paying with yinn coin functinality
    axios
      .get(Env.url + "/currency/yinnCoinExchangeRate", {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("auth_token"),
        },
      })
      .then((response) => {
        //setState({ yinnCoinExchangeValue: response.data.yinnCoinExchnageRate })
      })
      .catch((err) => {
        if (err.response != undefined) {
          if (
            err.response.status == 401 ||
            err.response.status == 400 ||
            err.response.status == 500
          ) {
            window.location = "#/login";
          }
        }
      });

    axios
      .get(Env.url + "/advertisement/adblock-detect", {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("auth_token"),
        },
      })
      .then((response) => {
        //setState({ adBlcoked: response.data.blocked });
      })
      .catch((err) => {
        //setState({ adBlcoked: true });
        if (err.response != undefined) {
          if (
            err.response.status == 401 ||
            err.response.status == 400 ||
            err.response.status == 500
          ) {
            window.location = "#/login";
          }
        }
      });
  };

  const payByCard = () => {
    //setState({
    //     paymentChecked: false,
    //     paypalChecked: true,
    //     ynCoinChecked: false
    // })
  };

  const payByPaypal = () => {
    //setState({
    //     paymentChecked: true,
    //     paypalChecked: false,
    //     ynCoinChecked: false
    // })
  };

  const payByYnCoin = () => {
    //setState({
    //     paymentChecked: true,
    //     paypalChecked: true,
    //     ynCoinChecked: false
    // })
    let pay = window.confirm("Are you sure you want to pay using Yn Coins?");
    if (pay) {
      axios
        .post(
          Env.url + "/payments/ads",
          {
            amount_payable: state.userCardDetails.amount_payable,
            paymentMethod: "yinnCoin",
            adData: payment_details.createAd,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: localStorage.getItem("auth_token"),
            },
          }
        )
        .then(function (response) {
          //setState({ ynCoinConfirmed: true });
          window.location = "#/advertisement";
        })
        .catch((err) => {
          if (err.response != undefined) {
            if (
              err.response.status == 401 ||
              err.response.status == 400 ||
              err.response.status == 500
            ) {
              window.location = "#/login";
            }
          }
        });
    }
  };

  const handleCardNumber = (evt) => {
    var number = evt.target.value.replace(/ +/g, "");
    if (/^[0-9]{1,19}$/.test(number)) {
      var cardFormat = creditcardutils.formatCardNumber(number);
      //setState({ creditCardNumber: cardFormat })
      var card = state.card;
      card.number = cardFormat.split(" ").join("");
      //setState({ card: card })
    } else if (number == "") {
      var cardFormat = creditcardutils.formatCardNumber(number);
      //setState({ creditCardNumber: cardFormat })
      var card = state.card;
      card.number = number;
      //setState({ card: card })
    }
  };

  const handleExpirationMonth = (evt) => {
    if (/^[0-9]{1,2}$/.test(evt.target.value)) {
      var card = state.card;
      var month = "0";
      if (evt.target.value.length == 1) {
        month = month + evt.target.value;
      } else {
        month = evt.target.value;
      }
      card.exp_month = month;
      //setState({
      //     card: card
      // })
    } else if (evt.target.value == "") {
      var card = state.card;
      card.exp_month = evt.target.value;
      //setState({
      //     card: card
      // })
    }
  };
  const handleExpirationYear = (evt) => {
    if (/^[0-9]{1,2}$/.test(evt.target.value)) {
      var card = state.card;
      card.exp_year = evt.target.value;
      //setState({
      //     card: card
      // })
    } else if (evt.target.value == "") {
      var card = state.card;
      card.exp_year = evt.target.value;
      //setState({
      //     card: card
      // })
    }
  };
  const handleCVV = (evt) => {
    if (/^[0-9]{1,4}$/.test(evt.target.value)) {
      var card = state.card;
      card.cvv = evt.target.value;
      //setState({
      //     card: card
      // })
    } else if (evt.target.value == "") {
      var card = state.card;
      card.cvv = evt.target.value;
      //setState({
      //     card: card
      // })
    }
  };

  const handleZipCode = (evt) => {
    if (/^[a-zA-Z0-9]{1,6}$/.test(evt.target.value)) {
      var card = state.card;
      card.zip = evt.target.value;
      //setState({
      //     card: card
      // })
    } else if (evt.target.value == "") {
      var card = state.card;
      card.zip = evt.target.value;
      //setState({
      //     card: card
      // })
    }
  };

  const chargeNewCard = () => {
    var card = state.card;
    var userCardDetails = state.userCardDetails;
    userCardDetails.user_id = cookie.load("_id");

    if (card.exp_month == "" || card.exp_month.length != 2) {
      //setState({ cardExp_month: true })
    } else {
      if (card.exp_month.length == 2) {
        var num = parseInt(card.exp_month);
        if (num >= 13) {
          //setState({ cardExp_month: true })
        } else {
          //setState({ cardExp_month: false })
        }
      } else {
        //setState({ cardExp_month: false })
      }
      if (card.exp_year == "" || card.exp_year.length != 2) {
        //setState({ cardExp_year: true })
      } else {
        if (card.cvv == "" || card.cvv.length == 2 || card.cvv.length == 1) {
          //setState({ cardCVV: true })
          //setState({ cardExp_month: false })
          //setState({ cardExp_year: false })
        } else {
          if (card.zip == "" || card.zip.length != 6) {
            //setState({ cardZip: true })
            //setState({ cardCVV: false })
            //setState({ cardExp_month: false })
            //setState({ cardExp_year: false })
          } else {
            //setState({ cardZip: false })
            //setState({ cardCVV: false })
            //setState({ cardExp_month: false })
            //setState({ cardExp_year: false })
            var crd = userCardDetails.card;
            crd.number = card.number;
            crd.exp_date = card.exp_month + "/" + card.exp_year;
            crd.cvv = card.cvv;
            crd.zip = card.zip;
            userCardDetails.card = crd;
            //setState({
            //     userCardDetails: userCardDetails
            // })
            if (
              !state.cardNumber &&
              !state.cardExp_month &&
              !state.cardExp_year &&
              !state.cardCVV &&
              !state.zip
            ) {
              //setState({ payment_response_flag: true })
              //setState({ payment_response_wait: true })
              toast.success(
                "Payment is in progress please don't click other part of application.",
                {
                  position: toast.POSITION.TOP_RIGHT,
                }
              );
              axios
                .post(
                  Env.url + "/payments/ads",
                  {
                    ...state.userCardDetails,
                    paymentMethod: "card",
                    adData: payment_details.createAd,
                  },
                  {
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: localStorage.getItem("auth_token"),
                    },
                  }
                )
                .then(function (response) {
                  if (response.data.paymentResult.success) {
                    payment_message = response.data.message;
                    //setState({ payment_response_wait: false })
                    //setState({ payment_response_success: false })
                    if (response.data.paymentResult.transaction != undefined) {
                      //setState({
                      //     transaction_amount: response.data.paymentResult.transaction.amount,
                      //     transaction_id: response.data.paymentResult.transaction.id,
                      //     currancy: response.data.paymentResult.transaction.currencyIsoCode
                      // })
                    }
                    window.location = "#/wallet";
                  } else {
                    if (response.data.paymentResult.errors != undefined) {
                      state.payment_response_wait = false;
                      //setState({ payment_response_wait: false })
                      //setState({ payment_response_success: true })
                      //setState({ payment_error_message: response.data.paymentResult.message })
                    }
                  }
                })
                .catch((err) => {
                  if (err.response != undefined) {
                    if (
                      err.response.status == 401 ||
                      err.response.status == 400 ||
                      err.response.status == 500
                    ) {
                      window.location = "#/login";
                    }
                  }
                });
            }
          }
        }
      }
    }
  };

  const onPaypalSuccess = (payment) => {
    axios
      .post(
        Env.url + "/payments/ads",
        {
          amount_payable: state.userCardDetails.amount_payable,
          paymentMethod: "paypal",
          paypalData: payment,
          adData: payment_details.createAd,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("auth_token"),
          },
        }
      )
      .then(function (response) {
        payment_message = "Payment is successful";
        //setState({ payment_response_flag: true })
        //setState({ payment_response_wait: true })
        //setState({ payment_response_wait: false })
        //setState({ payment_response_success: false })
        state.transaction_id = payment.id;
        state.transaction_amount = state.amount_payable;
        state.currancy = "USD";
        window.location = "#/advertisement";
      })
      .catch((err) => {
        if (err.response != undefined) {
          if (
            err.response.status == 401 ||
            err.response.status == 400 ||
            err.response.status == 500
          ) {
            window.location = "#/login";
          }
        }
      });
  };

  const saveTransaction = (transactionResponse) => {
    let transaction_id;
    if (transactionResponse.transaction != undefined) {
      transaction_id = transactionResponse.transaction.id;
    } else {
      transaction_id = transactionResponse.paymentID;
    }
    var transaction = {
      transaction_id: transaction_id,
      Transaction_Response: transactionResponse,
    };
    axios
      .post(Env.url + "/transaction/create", transaction, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("auth_token"),
        },
      })
      .then(function (response) {
        // save(payment_details.createAd);
        wallet();
      })
      .catch((err) => {
        if (err.response != undefined) {
          if (
            err.response.status == 401 ||
            err.response.status == 400 ||
            err.response.status == 500
          ) {
            window.location = "#/login";
          } else {
          }
        }
      });
  };

  const checkCardValid = (cardNumber, evt) => {
    // Validate a credit card number
    var is_Valid = creditcardutils.validateCardNumber(cardNumber); //=> true
    if (is_Valid) {
      state.cardNumber = false;
      //setState({ cardNumber: false })
    } else {
      state.cardNumber = true;
      //setState({ cardNumber: true })
    }
    // Get card type from number
    var cardType = creditcardutils.parseCardType(cardNumber);
    if (cardType == "amex") {
      state.cvvMaxLength = 4;
      //setState({ cvvMaxLength: 4 })
    } else {
      state.cvvMaxLength = 3;
      //setState({ cvvMaxLength: 3 })
    }
  };

  const wallet = () => {
    axios
      .get(Env.url + "/wallet/get/" + payment_details.id, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("auth_token"),
        },
      })
      .then(function (response) {
        state.wallets = response.data;
        //setState({ wallets: state.wallets });
        if (response.data.length <= 0) {
          if (state.ynCoinConfirmed) {
            alert("buy yn coins first!");
            props.history.push("/yinn_coin");
          } else {
            var data = {
              user_id: payment_details.id,
              type: payment_details.paymentPlan,
              transaction_type: "CREDIT",
              balance: 0,
              ads_balance: state.userCardDetails.amount_payable,
            };
            axios
              .post(Env.url + "/wallet/create", data, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: localStorage.getItem("auth_token"),
                },
              })
              .then(function (response) {
                //setState({ wallets: response.data });
                props.history.push("/wallet");
              })
              .catch((err) => {
                if (err.response != undefined) {
                  if (err.response.status == 401) {
                    window.location = "#/login";
                  }
                }
              });
          }
        } else {
          if (
            state.ynCoinConfirmed &&
            state.wallets[0].quantity <
              state.userCardDetails.amount_payable * state.yinnCoinExchangeValue
          ) {
            alert("not enough yn coins");
            props.history.push("/yinn_coin");
          } else {
            if (state.ynCoinConfirmed) {
              // aying using yinn coins, only yinn coins quantity deducted, balance still remain as it get adds again as an ad payment
              var data = {
                user_id: payment_details.id,
                type: payment_details.paymentPlan,
                transaction_type: "CREDIT",
                balance:
                  state.wallets[0].balance -
                  state.userCardDetails.amount_payable,
                quantity:
                  state.wallets[0].quantity -
                  state.userCardDetails.amount_payable *
                    state.yinnCoinExchangeValue,
                ads_balance:
                  state.wallets[0].ads_balance +
                  state.userCardDetails.amount_payable,
              };
            } else {
              var data = {
                user_id: payment_details.id,
                type: payment_details.paymentPlan,
                transaction_type: "CREDIT",
                balance: state.wallets[0].balance,
                ads_balance:
                  state.wallets[0].ads_balance +
                  state.userCardDetails.amount_payable,
              };
            }

            axios
              .put(Env.url + "/wallet/update/" + state.wallets[0]._id, data, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: localStorage.getItem("auth_token"),
                },
              })
              .then(function (response) {
                //setState({ wallets: response.data });
                props.history.push("/wallet");
              })
              .catch((err) => {
                if (err.response != undefined) {
                  if (
                    err.response.status == 401 ||
                    err.response.status == 400 ||
                    err.response.status == 500
                  ) {
                    window.location = "#/login";
                  }
                }
              });
          }
        }
      })
      .catch((err) => {
        if (err.response != undefined) {
          if (
            err.response.status == 401 ||
            err.response.status == 400 ||
            err.response.status == 500
          ) {
            window.location = "#/login";
          }
        }
      });
  };

  const onSuccess = (payment) => {
    // saveTransaction(payment)
    // Congratulation, it came here means everything's fine!
    onPaypalSuccess(payment);
    // You can bind the "payment" object's value to your state or props or whatever here, please see below for sample returned data
  };

  const onCancel = (data) => {
    // User pressed "cancel" or close Paypal's popup!

    console.log("The payment was cancelled!", data);
    // You can bind the "data" object's value to your state or props or whatever here, please see below for sample returned data
  };

  const onError = (err) => {
    // The main Paypal's script cannot be loaded or somethings block the loading of that script!
    console.log("Error!", err);
    // onPaypalError(err)
    // Because the Paypal's main script is loaded asynchronously from "https://www.paypalobjects.com/api/checkout.js"
    // => sometimes it may take about 0.5 second for everything to get set, or for the button to appear
  };

  let env = "sandbox"; // you can set here to 'production' for production
  let currency = "USD"; // or you can set this value from your props or state
  let total = state.userCardDetails.amount_payable; // same as above, this is the total amount (based on currency) to be paid by using Paypal express checkout
  // Document on Paypal's currency code: https://developer.paypal.com/docs/classic/api/currency_codes/

  const client = {
    sandbox:
      "ASQHvNZTgxugU6CHeydBRQFXCSA7lGVvFijLzuewhu8ouQwsMGCkIpQrsc7GhlUVdV90ttSuCVkBJ1Cc",
    production: "YOUR-PRODUCTION-APP-ID",
  };

  // const client = {
  // sandbox: 'APP-80W284485P519543T',
  // production: 'YOUR-PRODUCTION-APP-ID',
  // }

  return (
    <div className="animated fadeIn">
      <ToastContainer autoClose={20000} />
      {/* select payment modes */}
      {state.adBlcoked && (
        <Card>
          <CardHeader>
            <Row>
              <div style={{ marginTop: 10 }}>
                <h3 style={{ color: "red" }}>Ad Blocker Detected!</h3>
                This may affect the proper functionality of the advertisement
                module. Please disable the adblocker on this site and reload the
                page.
              </div>
            </Row>
          </CardHeader>
        </Card>
      )}
      <Row>
        <Col xs="3" md="3"></Col>
        <Col xs="6" md="6">
          <div class="container">
            <div class="card">
              <div class="title">
                <h1>Select Payment Method</h1>
              </div>

              <a>
                <div class="item item-selected" onClick={payByCard}>
                  <div class="item-image">
                    <img
                      class="paypal-image"
                      src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mastercard-logo.svg/200px-Mastercard-logo.svg.png"
                    ></img>
                  </div>
                  <div class="item-text">Credit/Debit/ATM Card</div>
                  <svg
                    hidden={state.paymentChecked}
                    class="check"
                    fill="#5AC550"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                  {/* card details ui */}
                  <Row hidden={state.payment_response_wait}>
                    <span class="pad-top-2"></span>
                    <Col xs="12" sm="12" hidden={state.paymentChecked}>
                      <Card>
                        <CardHeader>
                          <strong>Enter Card Details</strong>
                          {/* <small> Form</small> */}
                        </CardHeader>
                        <CardBody>
                          {/* <Col xs="12" sm="12" >
                                                            <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/346994/Card%20Icon.svg" alt="" />
                                                        </Col> */}
                          <Row>
                            <Col xs="12" sm="12">
                              <label>Card Number</label>
                              <Input
                                className="input-border"
                                type="text"
                                placeholder="0000 0000 0000 0000"
                                onChange={(e) => handleCardNumber(e)}
                                onBlur={checkCardValid.bind(
                                  this,
                                  state.card.number
                                )}
                                value={state.creditCardNumber}
                              />
                              <InputGroup
                                className="mb-3"
                                hidden={!state.cardNumber}
                              >
                                <div className="validations">
                                  Enter valid number.
                                </div>
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="12" sm="6">
                              <label className="form__label payment-ui">
                                Expiration month
                              </label>
                              <Input
                                className="input-border"
                                type="select"
                                onChange={(e) => handleExpirationMonth(e)}
                                maxLength={2}
                              >
                                {state.month.map((month, index) => (
                                  <option value={month}>{month}</option>
                                ))}
                              </Input>
                              <InputGroup
                                className="mb-3"
                                hidden={!state.cardExp_month}
                              >
                                <div className="validations">
                                  Enter valid month.
                                </div>
                              </InputGroup>
                            </Col>
                            <Col xs="12" sm="6">
                              <label className="form__label payment-ui">
                                Expiration year
                              </label>
                              <Input
                                className="input-border"
                                type="text"
                                placeholder="00"
                                onChange={(e) => handleExpirationYear(e)}
                                value={state.card.exp_year}
                                maxLength={2}
                              />
                              <InputGroup
                                className="mb-3"
                                hidden={!state.cardExp_year}
                              >
                                <div className="validations">
                                  Enter valid year.
                                </div>
                              </InputGroup>
                            </Col>
                            <Col xs="12" sm="6">
                              <label
                                className="form__label payment-ui"
                                for="cvv"
                              >
                                CVV
                              </label>
                              <Input
                                className="input-border"
                                type="text"
                                onChange={(e) => handleCVV(e)}
                                value={state.card.cvv}
                                maxLength={state.cvvMaxLength}
                              />
                              <InputGroup
                                className="mb-3"
                                hidden={!state.cardCVV}
                              >
                                <div className="validations">
                                  Enter valid cvv.
                                </div>
                              </InputGroup>
                            </Col>
                            <Col xs="12" sm="6">
                              <label
                                className="form__label payment-ui"
                                for="cvv"
                              >
                                Billing Zip Code
                              </label>
                              <Input
                                className="input-border"
                                type="text"
                                onChange={(e) => handleZipCode(e)}
                                value={state.card.zip}
                                maxLength={6}
                              />
                              <InputGroup
                                className="mb-3"
                                hidden={!state.cardZip}
                              >
                                <div className="validations">
                                  Enter valid zip.
                                </div>
                              </InputGroup>
                            </Col>
                            <Col xs="12" sm="1">
                              <label
                                className="form__label payment-ui"
                                for="cvv"
                              >
                                &nbsp;
                              </label>
                              <Button
                                type="button"
                                className="payment-button"
                                onClick={(e) => chargeNewCard(e)}
                              >
                                PAY $ {state.userCardDetails.amount_payable}
                              </Button>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  {/* end of card details ui */}
                  {/* show spinner*/}
                  <Row hidden={!state.payment_response_wait}>
                    <div class="spinner-wave">
                      <div class="mar-right-4"></div>
                      <div class="mar-right-4"></div>
                      <div class="mar-right-4"></div>
                      <div class="mar-right-4"></div>
                      <div class="mar-right-4"></div>
                    </div>
                  </Row>
                  {/* end of spinner */}
                </div>
              </a>
              <a>
                <div class="item" onClick={payByPaypal}>
                  <PayPalButton
                    amount={state.userCardDetails.amount_payable}
                    // shippingPreference="NO_SHIPPING" // default is "GET_FROM_FILE"
                    onSuccess={(details, data) => {
                      onPaypalSuccess(details);
                      // OPTIONAL: Call your server to save the transaction
                    }}
                    options={{
                      clientId:
                        "AcBy0s6ShxWoOTUFmVqLgt61HTUhzWEP5IXnpOgYkq0GAODr1tYvyzHUGSX-IPcFx6k0dLUMb0FvtC_F",
                      disableCard: "visa,mastercard,amex",
                    }}
                  />
                  {/* <div class="item-text">
                                            Paypal</div> */}
                  <svg
                    hidden={state.paypalChecked}
                    class="check-box"
                    fill="#5AC550"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                </div>
              </a>
              <a>
                <div class="item item-selected" onClick={payByYnCoin}>
                  <div class="item-image">
                    <img class="paypal-image" src={Yncoin}></img>
                  </div>
                  <div class="item-text">
                    Pay Using Yn Coins -{" "}
                    {state.userCardDetails.amount_payable *
                      state.yinnCoinExchangeValue}{" "}
                    Coins
                  </div>
                </div>
              </a>
            </div>
          </div>
        </Col>
        <Col xs="3" md="3"></Col>
      </Row>
      {/* endo of select payment modes */}

      {/* card payment page */}

      {/* end of card payment page */}
    </div>
  );
};

export default AdsPayment;
